import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import type { OnyxIconBoxColor } from '../enums';

@Component({
  selector: 'onyx-icon-box',
  imports: [TranslatePipe],
  templateUrl: './onyx-icon-box.component.html',
  styleUrl: './onyx-icon-box.component.scss',
})
export class OnyxIconBoxComponent {
  public readonly color = input<`${OnyxIconBoxColor}`>('black');
  public readonly label = input<string | null>(null);
  public readonly hasColoredBackground = input(false);
  public readonly hasTransparentBackground = input(false);
  public readonly hasShadow = input(false);
  public readonly align = input<'start' | 'center' | 'end'>('center');
  public readonly size = input(24);
  public readonly gap = input(12);
  public readonly isCentered = input(false);
}
